// #region imports

// ---Angular
import { Component, OnInit } from '@angular/core';

// ---RxJs
import { Observable } from 'rxjs';

// 3rd Party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { AppService } from '../services/app.service';
import { environment } from 'src/environments/environment';

// #endregion

@Component({
  selector: 'hs-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.scss']
})
export class ReportModalComponent implements OnInit {
  showReportModal$: Observable<boolean>;
  reportText: string;

  constructor(private appService: AppService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  onClick(): void {
    const url =
      environment.apiConfig.webClient + environment.apiConfig.reportsOnlineApi + `/${this.reportText}`;
    const hwnd = window.open(url, '_blank');
    this.activeModal.close('View Report Clicked');
  }

  onDismiss(): void {
    this.activeModal.close('Cross click');
  }
}
